import APIError from '../APIError';
class NotFound extends APIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        const status = 404;
        super(status, ...args);
    }
}
export default NotFound;
